// user pressed ctrl+f or cmd+f
export var isFindEvent = function (_a) {
    var key = _a.key, ctrlKey = _a.ctrlKey, metaKey = _a.metaKey;
    return key === 'f' && (ctrlKey || metaKey);
};
